import { EntityListConfig, SortDirection, EntityListColumn, IEntityListConfig } from '@mt-ng2/entity-list-module';
import { ICarrier } from '../../model/interfaces/carrier';
import { ArchiveCarrierListComponent } from './archive-carrier-list/archive-carrier-list.component';

export class CarriersEntityListConfig extends EntityListConfig {
    constructor() {
        const listConfig: IEntityListConfig = {
            columns: [
                new EntityListColumn({
                    name: 'Name',
                    sort: {
                        defaultDirection: SortDirection.Asc,
                    },
                }),
                new EntityListColumn({
                    component: ArchiveCarrierListComponent,
                    fireOnColumnSelected: false,
                    name: 'Archive',
                    sort: {
                        disableSort: true,
                    },
                }),
            ],
            rowClass: (entity: ICarrier) => entity.Archived ? 'archived' : '',
        };
        super(listConfig);
    }
}
